export default "__VITE_PUBLIC_ASSET__4abc14f4__"